import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import EnhancedCalendar from "@/components/calendar/EnhancedCalendar";
import ParentCalendarView from "@/components/calendar/ParentCalendarView";
import { useParentData } from "@/hooks/useParentData";

export default function ParentCalendar() {
  const { user } = useAuth();
  const { children, loading } = useParentData();

  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      <header>
        <h1 className="text-3xl font-bold">Calendar</h1>
        <p className="text-muted-foreground">Schedules across all of your children.</p>
      </header>
      {loading ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : (
        <>
          <ParentCalendarView children={children} />
          <Card>
            <CardHeader>
              <CardTitle>Tutoring Schedule Calendar</CardTitle>
              <CardDescription>View all scheduled tutoring sessions for your children</CardDescription>
            </CardHeader>
            <CardContent>
              <EnhancedCalendar userId={user?.email || ""} userType="parent" children={children} />
            </CardContent>
          </Card>
        </>
      )}
    </div>
  );
}
